/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleinfluencestrong3Inputs */



/**
* | output |
* | --- |
* | "You know how to shape the emotional atmosphere around you and help other people feel calmer and more confident." |
*
* @param {Eisubscaleinfluencestrong3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleinfluencestrong3 = /** @type {((inputs?: Eisubscaleinfluencestrong3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleinfluencestrong3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You know how to shape the emotional atmosphere around you and help other people feel calmer and more confident.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sabes influir en el clima emocional a tu alrededor y ayudas a los demás a sentirse más tranquilos y seguros.")
	return /** @type {LocalizedString} */ ("Ты умеешь влиять на эмоциональную атмосферу вокруг и помогаешь другим людям почувствовать себя спокойнее и увереннее.")
});
export { eisubscaleinfluencestrong3 as "eiSubscaleInfluenceStrong" }